import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CartProvider } from './contexts/CartContext';

import Register from './components/Register';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import EditProfile from './components/EditProfile';
import NotFound from './components/NotFound';
import ChangePassword from './components/ChangePassword';
import ManageKids from './components/ManageKids';
import Book from './components/Book';
import Orders from './components/Orders';

import 'rsuite/dist/rsuite.min.css';

function MainApp() {
  const [toastPosition, setToastPosition] = useState(() => 
    window.innerWidth >= 1024 ? 'top-center' : 'bottom-center'
  );

  useEffect(() => {
    const handleResize = () => {
      setToastPosition(window.innerWidth >= 1024 ? 'top-center' : 'bottom-center');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <CartProvider>

      <Routes>
        <Route exact path="/" element={<ManageKids />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/resetPassword" element={<ResetPassword />} />
        <Route path="/book" element={<Book />} />
        <Route path="/review" element={<Book />} />
        <Route path="/payment" element={<Book />} />
        <Route path="/payment-complete" element={<Book />} />
        <Route path="/thank-you" element={<Book />} />
        <Route path="/manage" element={<ManageKids />} />
        <Route path="/history" element={<Orders />} />
        <Route path="/profile" element={<EditProfile />} />
        <Route path="/password" element={<ChangePassword />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ToastContainer
        position={toastPosition}
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

    </CartProvider>
  );
}

export default MainApp;
